import {combineReducers} from 'redux';
import successStore from './successStore';

const rootReducer = combineReducers({
    successStore
});

export default rootReducer;
